var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0276B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6495 22.1316H9.87865V13.2212H12.6495V22.1316ZM11.2641 12.0072C10.3745 12.0072 9.65625 11.2889 9.65625 10.403C9.65625 9.51706 10.3745 8.79883 11.2641 8.79883C12.15 8.79883 12.8682 9.51706 12.8682 10.403C12.8682 11.2853 12.15 12.0072 11.2641 12.0072ZM23.0182 22.1316H20.251V17.8004C20.251 16.7686 20.2328 15.4379 18.8109 15.4379C17.3708 15.4379 17.1521 16.5645 17.1521 17.7275V22.1316H14.3885V13.2212H17.0427V14.4389H17.0792C17.4474 13.7389 18.3516 12.9988 19.6969 12.9988C22.5005 12.9988 23.0182 14.8436 23.0182 17.2426V22.1316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.8604a2e75206a37d6c51bef6740c05bc.svg";
export { ForwardRef as ReactComponent };